import { HttpClient } from '@angular/common/http';
import { StorageService, STORAGE_KEY } from '@core/services/storage/storage.service';
import { Injectable } from '@angular/core';
import { AuthData } from '@api/models';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient, private storageService: StorageService) {}

  isLogged() {
    return !!this.storageService.getItem(STORAGE_KEY.TOKEN);
  }

  authenticate(authData: AuthData, otpSecretKey?: string) {
    const headers = { Authorization: `Basic ${environment.authorization}` };
    const params = { platform: 'web', version: '*' };

    if (otpSecretKey) {
      headers['X-Otp-Value'] = otpSecretKey;
    }

    const url = `${environment.apiBasePath}${environment.endpoints.authenticate}`;

    return this.httpClient.post<{ access_token: string; userBe?: string, id_interno_pe?: string }>(url, authData, {
      headers,
      params,
    });
  }

  activate(userBe: string, password: string) {
    const url = `${environment.apiBasePath}${environment.endpoints.activate}`;
    const headers = { Authorization: `Basic ${environment.authorization}`, 'X-User-Be': userBe };

    return this.httpClient.post<any>(url, { password, confirm_password: password }, { headers });
  }

  logout() {
    const url = `${environment.apiBasePath}${environment.endpoints.revoke}`;
    return this.httpClient.delete<void>(url);
  }
}
